import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
})
export class SignupComponent extends BaseCtl implements OnInit {
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    locator.config.getProperty('endpoint.login').then((property: string) => {
      this.initApiEndpoint(property);
    });
  }

  override ngOnInit(): void {
    let _self = this;
    _self.locator.config
      .getProperty('DEFAULT_ORGNIZATION_ID')
      .then((property: string) => {
        _self.form.data['orgId'] = property;
      });
  }

  override populateForm(form: any, data: any) {
    form.data.firstName = data.firstName;
    form.data.lastName = data.lastName;
    form.data.login = data.login;
    form.data.password = data.password;
  }

  isLogin = false;

  signup() {
    var _self = this;

    Object.keys(this.form.data).forEach((key) => {
      if (typeof this.form.data[key] === 'string') {
        this.form.data[key] = this.form.data[key].trim();
        console.log(this.form.data[key]);
      }
    });

    _self.locator.config
      .getProperty('endpoint.login')
      .then((property: string) => {
        let url = property + '/signup';
        _self.form.data['orgId'] = _self.locator.config.get(
          'DEFAULT_ORGNIZATION_ID'
        );
        _self.form.data['roleName'] = _self.locator.config.get('DEFAULT_ROLE');

        this.locator.http.post(
          url,
          this.form.data,
          function (res: any, error: any) {
            console.log('response', res);
            _self.form.message = '';
            _self.form.inputerror = {};

            if (res.success) {
              _self.isLogin = true;
            } else {
              _self.form.error = true; 
              if (res.result && res.result.inputerror) {
              _self.form.inputerror = res.result.inputerror;
                  const errors = Object.values(res.result.inputerror);
                 _self.form.message = errors.join(', ');   
               } else {
                     _self.form.message = res.result?.message || res.message || '';
                }
            }
          }
        );
      });
  }

  //------show Password---------
  showPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  
}
